import React, { useState, useEffect } from 'react';
import DivisionElement from './divisionElement';

const DivisionTree = ({ divisions, sel, setSel }) => {


    
    
    return (

        divisions.map((i, ix) => <DivisionElement division={i} level={0} sel={sel} setSel={setSel} key={ix} />)
        )



}

export default DivisionTree;

